/**
 * 파일 저장
 * @param data
 * @param isRemote
 * @returns
 */
export const ADD_FILE = 'ADD_FILE';
/**
 * 메시지 저장
 * @param data
 * @param isRemote
 * @returns
 */
export const ADD_MESSAGE = 'ADD_MESSAGE';
/**
 * 채팅 전송할 사용자 설정
 * @param members
 * @returns
 */
export const SET_CHOICE_MEMBER = 'SET_CHOICE_MEMBER';
/**
 * 채팅 read
 */
export const SET_IS_CHAT_READ = 'SET_IS_CHAT_READ';
export const ADD_MESSAGE_LIST = 'ADD_MESSAGE_LIST';
export const ADD_FILE_MESSAGE = 'ADD_FILE_MESSAGE';
export const SWITCH_TO_LIVE_MESSAGE = 'SWITCH_TO_LIVE_MESSAGE';
export const SET_IS_KEYBOARD_OPEN = 'SET_IS_KEYBOARD_OPEN';
// 최신 채팅 보고 있는 상태 (가장 아래 메시지)
export const SET_IS_LIVE = 'SET_IS_LIVE';
